import React, { useEffect, useState } from 'react';
import { post, get, put } from '../../api';
import {
  BrowserRouter as Router,
  useNavigate,
} from 'react-router-dom';
import { useDispatch, useSelector, useStore } from 'react-redux';
import CompanyAccount, { IAccountProps } from '../../components/account/companyAccount';

export default function AccountContainer () {

  
  const [companyData, setCompanyData] = useState();

  const [messageInternal, setMessageInternal] = useState<string>('');
  const [errorMessageInternal, setErrorMessageInternal] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchComapnyData = async() => {

    setLoading(true);

    const result = await get('company');

    if (result.status === 200) {
      setCompanyData(result);
    } else {
      console.log('failed to fetch', result);
    }

    setLoading(false);
    
  };
  

  useEffect(()=>{
    fetchComapnyData();
  },[]);
  
  const updateDataHandler = async (data: IAccountProps) => {

    setLoading(true);

    const result = await put('company', data);

    if (result.status === 200) {
      setErrorMessageInternal('');
      setMessageInternal('Company data updated!');
    } else {
      setErrorMessageInternal('An error occured, failed to update. ' + result.data?.message);
    }

    setLoading(false);
  };

  return (<><CompanyAccount 
    loading={loading}
    successMessage={messageInternal}
    errorMessage={errorMessageInternal}
    onUpdate={updateDataHandler}
    defaultProps={companyData}
  />
  </>);
}